<template>
  <div class="container">
    <div ref="fireEchart" style="width: 100%;height: 100%;"></div>
    <div class="select">
      <p @click="chooseTime(item.index)" class="datachoose center" v-for="item in chooseList" :key="item.index" :class="{ choosecolor: activeVar == item.index }">
        {{ item.name }}
      </p>
    </div>
  </div>
</template>
<script>
import { fireAlarmCountTrend } from '@/api/report.js';
export default {
  props: ['cpNum'],
  data() {
    return {
      list: [],
      AlarmCountTrendTime: [],
      AlarmCountTrendValue: [],
      chooseList: [
        { index: 1, name: '1d' },
        { index: 2, name: '3d' },
        { index: 3, name: '7d' },
        { index: 4, name: '15d' },
        { index: 5, name: '30d' },
        { index: 6, name: '12m' },
      ],
      activeVar: 1,
    };
  },
  watch: {
    cpNum() {
      this.chooseTime(1);
    },
  },
  created() {},
  mounted() {},
  methods: {
    // 时间选择
    chooseTime(index) {
      this.activeVar = index;
      switch (index) {
        // 获取1d
        case index:
          if (this.cpNum == 'ee7a45afdd0540d59efc25eb7f3bde74') {
            fireAlarmCountTrend({ companyNum: 'fe559562bb2b456b848a545bb5d2eb4a', type: index }).then((res) => {
              // log(res, "火警数据趋势图");
              this.list = res.data;
              this.AlarmCountTrendTime = this.list?.map((item) => item.timeStr);
              this.AlarmCountTrendValue = this.list?.map((item) => item.value);
              this.initChart(this.AlarmCountTrendTime, this.AlarmCountTrendValue);
            });
          } else {
            fireAlarmCountTrend({ companyNum: this.cpNum, type: index }).then((res) => {
              // log(res, "火警数据趋势图");
              this.list = res.data;
              this.AlarmCountTrendTime = this.list?.map((item) => item.timeStr);
              this.AlarmCountTrendValue = this.list?.map((item) => item.value);
              this.initChart(this.AlarmCountTrendTime, this.AlarmCountTrendValue);
            });
          }
          break;
      }
    },
    initChart(time, value) {
      let fireTrend = this.$echarts.init(this.$refs.fireEchart);
      var FireChartOptions = {
        tooltip: {
          trigger: 'axis',
          confine: true,
        },

        dataZoom: [
          {
            height: '20',
            bottom: '2',
          },
          {
            type: 'inside',
          },
        ],
        grid: {
          top: '10%',
          left: '7%',
          right: '3%',
          bottom: '17%',
        },
        xAxis: {
          axisLine: {
            //x轴坐标轴，false为隐藏，true为显示
            show: false,
          },
          boundaryGap: false,
          // name: '时间',
          nameLocation: 'end',
          type: 'category',
          data: time,
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 9,
            },
          }, //显示x轴的数值
        },
        yAxis: {
          type: 'value',
          splitLine: { show: false },
          axisLabel: {
            show: true,
            textStyle: {
              fontSize: 8,
            },
          },
        },
        series: [
          {
            showAllSymbol: true, //标注所有数据点
            data: value,
            type: 'line',
            symbol: '',
            itemStyle: {
              normal: {
                color: 'gray', //改变折线点的颜色
                lineStyle: {
                  color: 'rgba(63, 64, 72, 1)', //改变折线颜色
                },
              },
            },
          },
        ],
      };
      fireTrend.setOption(FireChartOptions);
      window.addEventListener('resize', function() {
        fireTrend.resize();
      });
    },
  },
};
</script>
<style lang="scss" scoped>
.container {
  width: 100%;
  height: 75%;
  display: flex;
  border: 1px solid #2196f3;
  position: relative;

  .select {
    display: flex;
    align-items: center;
    float: right;
    padding-right: 8px;
    position: absolute;
    right: 0;
    z-index: 99;

    p {
      width: 25px;
      margin: 3px 0 5px 10px;
      border-radius: 15px;
      text-align: center;
      height: 20px;
      font-size: 12px;
    }
    .datachoose {
      display: flex;
      font-size: 10px;
      font-weight: 400;
      color: #000;
      text-align: center;
      line-height: 20px;
      cursor: pointer;
      z-index: 99;
    }
    .chosse {
      width: 50px;
      height: 15px;
      border-radius: 45%;
      background-color: rgb(192, 191, 191);
    }
    .fireChart {
      width: 100;
      height: 100%;
      z-index: 999;
    }
  }
}
.choosecolor {
  width: 55px;
  height: 15px;
  border-radius: 45%;
  background-color: rgb(196, 196, 196);
}
</style>
